import classes from '../styles/Footer.module.css';

const Footer = () => (
  <div>
    <div className={classes.Footer}>
      <span className={classes.FooterText}>
        &copy; Copyright 2023 The Prisoner API
      </span>
    </div>
  </div>
);

export default Footer;
